import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector'
import { sort } from './common'
import {filteredCollection} from './filters'
import { createSearchAction, getSearchSelectors } from 'redux-search'
import { incomeStatementByPropertyID } from './perfomance'
import { leasesByPropertyID } from './leases'

let {
	text
  , result //  ids
  , unfilteredResult
} = getSearchSelectors({
  resourceName: 'property',
  resourceSelector: (resourceName, state) => {let res = filteredCollection('property')(state); return res}
})
export let propertiesTable = createSelector(
	[filteredCollection('property'), text, result, unfilteredResult, sort('property', {secondary: 'alias'})],
	(propertiesEx, text, result, unfilteredResult, sort) => {
		if(text) {
			// console.log("prop propertiesEx", propertiesEx)
			// console.log("prop text", text)
			// console.log("prop result", result)
			// propertiesEx = R.indexBy(R.prop('_id'), propertiesEx)
			propertiesEx = R.map(id => propertiesEx[id], result)
			// console.log("prop propertiesEx MAPPED", propertiesEx)
		}
		return sort.fn(propertiesEx)
 	}
 )

 export let propertiesLLTable = createSelector(
 	[propertiesTable, incomeStatementByPropertyID, leasesByPropertyID],
 	(propertiesTable, incomeStatement, leasesByPropertyID) => {
 		let tableData = propertiesTable
 		let totalRent = 0

		let extend = property => {
			let rent = R.reverse(R.sortBy(R.prop('breakDateTill') || R.prop('dateTill'))(leasesByPropertyID[property._id] || []))[0]
			rent = rent && rent.rent || 0
			return{
				...property
				, income: incomeStatement.netIncome[property._id] || 0
				, rent
				, status: property.status=="Occupied" && parseInt(incomeStatement.pendingRent[property._id])>0?"Occupied Unpaid": property.status
			}
		}
		tableData = R.map(extend)(tableData)
 		R.map(x => totalRent += +x.rent)(tableData)
 		tableData.unshift({_id:false, alias:"Entire Portfolio", income: incomeStatement.netIncome['total'], rent: totalRent})

 		return tableData
  	}
  )



// WEBPACK FOOTER //
// ./src/selectors/propertiesTable.js